import { Capacitor } from "@capacitor/core";

export default function getLinkToS3(fileName) {
  let environment = "production";

  if (window.location.host.indexOf("localhost") !== -1) {
    environment = "development";
  }

  if (window.location.host.indexOf("192.168") !== -1) {
    environment = "development";
  }

  let platform = Capacitor.getPlatform();

  if (platform !== "web") {
    let isDev = window.location.href.startsWith("http://");

    if (isDev) {
      environment = "development";
    } else {
      environment = "production";
    }
  }

  let useCDN = true;

  let base = "http://djizef-s3-storage-bucket.s3.eu-west-3.amazonaws.com";

  let cdnBase = `https://d27ddt4sib84c2.cloudfront.net`;

  if (useCDN) {
    base = cdnBase;
  }

  base = cdnBase;

  return `${base}/${environment}/continental-security/${fileName}`;
}
